export default {
  create: {
    success: 'Liste de diffusion créée avec succès',
    error: 'Impossible de créer la liste de diffusion'
  },
  update: {
    success: 'La modification sur la liste de diffusion a été effectuée avec succès',
    error: 'Impossible de modifier la liste de diffusion'
  },
  import: {
    success: 'Importation effectuée avec succès',
    error: 'Importation échouée'
  }
}
